import { createContext, useContext } from "react";
const initialContext = { resetUrqlClient: () => undefined };
export const IlmoContext = createContext(initialContext);
export function useIlmoContext() {
    return useContext(IlmoContext);
}
//# sourceMappingURL=context.js.map